import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PromoModal } from '@cian/frontend-newbuilding-promo-modal-widget';

import { Controls } from './Controls';
import { usePreparedPromo } from './hooks';
import { trackLinkClick } from './tracking';
import { closePromoDetails } from '../../actions/promoDetails';
import { usePromoDetailsConfig } from '../../hooks';
import { selectIsPromoDetailsOpen, selectPromoDetails, selectPromoProduct } from '../../selectors/promoDetails';
import { IPromoProduct } from '../../types/product';

export const PromoDetailsModalContainer = () => {
  const isOpen = useSelector(selectIsPromoDetailsOpen);
  const promoDetails = useSelector(selectPromoDetails);
  const promoProduct = useSelector(selectPromoProduct);
  const dispatch = useDispatch();

  const preparedPromo = usePreparedPromo();
  const promoModalConfig = usePromoDetailsConfig();

  const closePromoDetailsModal = React.useCallback(() => {
    dispatch(closePromoDetails());
  }, [dispatch]);

  const handleNewbuildingListingLinkClick = React.useCallback(() => {
    trackLinkClick({ product: promoProduct as IPromoProduct, type: 'to_listingjk' });
  }, [promoProduct]);

  const handleNewbuildingLinkClick = React.useCallback(() => {
    trackLinkClick({ product: promoProduct as IPromoProduct, type: 'to_jk' });
  }, [promoProduct]);

  if (!isOpen || !preparedPromo) {
    return null;
  }

  return (
    <PromoModal
      open={true}
      onOpenChange={closePromoDetailsModal}
      promo={preparedPromo}
      controls={<Controls />}
      config={promoModalConfig}
      onNewbuildingListingLinkClick={handleNewbuildingListingLinkClick}
      onNewbuildingLinkClick={handleNewbuildingLinkClick}
      newbuildingCountText={promoDetails?.newbuildingCountText}
    />
  );
};
